import axios from "axios";
import { useCallback, useMemo } from "react";

import { bffEndpoints } from "@api/Endpoints";
import { handleError } from "@utils/axios-utils";
import { axiosInstance } from "@utils/axiosInstance";

export function useInvalidateToken() {
  const invalidateToken = useCallback(async () => {
    try {
      const url = bffEndpoints.invalidateToken();
      return axiosInstance.delete(url);
    } catch (axiosError) {
      if (axios.isAxiosError(axiosError)) {
        return handleError(axiosError);
      }
    }
  }, []);

  return useMemo(
    () => ({
      invalidateToken
    }),
    [invalidateToken]
  );
}
